import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Button } from '@dojo/widgets/button';
import { recommended } from '@holmescorp/lcc-state';
import { publish } from '@holmescorp/pub-sub';
import css from '../../css/pretestReview.m.css';
import { Card } from '../../widgets';
const factory = create({
    theme,
    recommended
}).properties();
export const PretestReviewCard = factory(({ id, properties, middleware: { theme, recommended } }) => {
    const { nlsKey = '', mediaSrc = '', mediaTitle = '', title, subtitle = '', button_label = 'Begin', button_label_complete = 'Review', quizId = 'pre-test', ispromotedisabled = 'true', ispromotable = 'false', ispromoted = 'false' } = properties();
    const themeCss = theme.classes(css);
    const label = recommended.assessmentsComplete() ? button_label_complete : button_label;
    return v('div', { id, classes: [theme.variant(), themeCss.root] }, [
        w(Card, { mediaSrc, mediaTitle, nlsKey, ispromotable, ispromotedisabled, ispromoted }, [
            {
                content: v('div', { classes: [themeCss.content] }, [
                    v('div', { classes: [themeCss.title] }, [title]),
                    v('div', { classes: [themeCss.subtitle] }, [subtitle]),
                    v('div', { classes: [themeCss.actions] }, [
                        w(Button, {
                            onClick: () => {
                                publish('site/assessment', quizId);
                            },
                            aria: { label: `${label} ${title}` }
                        }, [
                            {
                                label
                            }
                        ])
                    ])
                ])
            }
        ])
    ]);
});
export default PretestReviewCard;
